export default __webpack_public_path__ + "static/media/spateMan.e6760e41.png";